/* eslint-disable no-unused-vars */
/* eslint-disable no-invalid-this */
/* eslint-disable max-len */
// CONSTANTS are all caps.
const NS = 'TabContainer';
const CLS = 'tabContainer';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/tabContainer.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import utils from '../utils';

export class TabContainer {
	constructor($el) {
		// $el is the widget node return by the loadTabContainer function
		this.$el = $el;
	}

	init() {
		this.setTabContainer();
	}

	setTabContainer() {
		// Add Some logic here
		const This = this;
		let $wg = $(this.$el);
		let tabsTitles = $wg.find(WG + 'tabTitlesWrapper');
		const TI = '.tabItem-';
		const TIB = '[data-wg="TabItem"]';
		const header = $('.siteHeader');
		let initTopPosition;

		// loop through tabItems and create tab triggers outside the tab container
		let tabItems = $wg.find(TIB);
		if (tabItems && tabItems.length > 0) {
			const hasHash = window.location.hash;
			if (hasHash) {
				// it needs to wait untill the  heroBanner animation completes
				setTimeout(() => {
					const $activeHash = tabItems.filter(`[data-id="${hasHash.substring(1).toLowerCase()}"]`);
					const $activeTitle = $activeHash.find(`${TI}tabTitle`);
					$activeTitle .trigger('click');
					$wg.find('.dropdown-toggle').text($activeTitle.text());
				}, 3500);
			}
			// generate mobile dropdown
			let mobileDropdownHtml = `
				<div class="mobile-dropdown d-md-none position-relative">
					<button class="dropdown-toggle" type="button" data-toggle="dropdown"></button>
					<div class="dropdown-menu"></div>
				</div>
			`;
			tabsTitles.find('.container').append(mobileDropdownHtml);

			tabItems.each(function(i) {
				let tabTitle = $(this).find(`${TI}tabTitle`);
				let title = tabTitle.text();
				let id = This.generateId() + '-tabTrigger';
				let titleHtml = `<span role="button" class="${CLS}-tabTrigger d-none d-md-inline-block" id="${id}">${title}</span>`;
				const tabItemId = $(this).data('id').toLowerCase();
				if (tabItemId) {
					$(this).attr('data-id', tabItemId);
				}
				tabTitle.attr('data-id', id);
				tabsTitles.find('.container').append(titleHtml);
				// append to mobile menu
				tabsTitles.find('.dropdown-menu').append(`
					<span class="dropdown-item" data-id="${id}">${title}</span>
				`);
				// first tab is active by default
				if (i == 0) {
					tabItems.first().find(`${TI}tabTitle`).addClass('is-active');
					tabsTitles.find(WG + 'tabTrigger').first().addClass('is-active');
					tabItems.first().find(`${TI}tabContent`).fadeIn('fast', function() {
						$(window).trigger('resize');
						// setPosition
						tabItems.first().find('.slick-initialized').slick('setPosition');
					});
					// put the initial mobile dropdown button text
					tabsTitles.find('.dropdown-toggle').text(title);
				}
			});

			$wg.on('click', '.dropdown-item', function() {
				let $this = $(this);
				let id = $this.data('id');
				$wg.find('.dropdown-item').removeClass('active');
				$this.addClass('active');
				$wg.find('.dropdown-toggle').text($this.text());
				tabItems.find(`[data-id=${id}]`).trigger('click');
			});

			$wg.find('.tabItem-tabContent').wrap('<div class="container"></div>');

			initTopPosition = tabsTitles.offset().top;

			// scroll stuff
			$(window).on('scroll', function() {
				let $activeTab = $wg.find('.tabItem-tabTitle.is-active').closest('.tabItem');
				let tabsTitlesReachedScroll = $(window).scrollTop() + ((header.length > 0) ? header.outerHeight() : 0) > initTopPosition;

				if (tabsTitlesReachedScroll && !utils.isElementOutViewport($wg)) {
					$('body').css({
						'overflow-x': 'visible',
					});

					tabsTitles.addClass('is-sticky');

					tabsTitles.css({
						'top': ((header.length > 0) ? header.outerHeight() : 0),
					});

					$activeTab.css({
						'padding-top': tabsTitles.outerHeight(),
						'padding-bottom': ((header.length > 0) ? header.outerHeight() : 0),
					});
				} else {
					$('body').css({
						'overflow-x': '',
					});

					tabsTitles.removeClass('is-sticky');

					tabsTitles.css({
						'top': '',
					});

					// remove all top paddings
					tabItems.css({
						'padding-top': '',
						'padding-bottom': '',
					});
				}
			});

			$(window).trigger('scroll');
		}

		// get clicks on titles [below the breakpoint]
		tabItems.on('click', `${TI}tabTitle`, function(e) {
			e.stopPropagation();

			let parentItem = $(this).closest(`${TIB}`);
			let hashValue = parentItem.data('id').toLowerCase();
			window.location.hash = hashValue;
			let id = $(this).attr('data-id');

			// if ($(this).hasClass('is-active')) {
			// 	parentItem.find(`${TI}tabContent`).hide(0);
			// 	parentItem.find(`${TI}tabTitle`).removeClass('is-active');
			// 	$wg.find(`#${id}`).removeClass('is-active');
			// 	return;
			// }

			tabItems.not(parentItem).find(`${TI}tabContent`).hide(0);
			tabItems.not(parentItem).find(`${TI}tabTitle`).removeClass('is-active');
			// show current item
			parentItem.find(`${TI}tabContent`).fadeIn('fast', function() {
				$(window).trigger('resize');
				if (tabsTitles.hasClass('is-sticky')) {
					$('html, body').animate({
						scrollTop: $wg.offset().top + $wg.find(WG + 'title').outerHeight() + (This.isBelowMd() ? 5 : 42),
					}, 500, function() {
						$(window).trigger('scroll');
					});
				} else {
					$('html, body').animate({
						scrollTop: $wg.offset().top,
					}, 500, function() {
						$(window).trigger('scroll');
					});
				}
				// setPosition
				parentItem.find('.slick-initialized').slick('setPosition');
			});
			parentItem.find(`${TI}tabTitle`).addClass('is-active');
			$wg.find(WG + 'tabTrigger').not(`#${id}`).removeClass('is-active');
			$wg.find(`#${id}`).addClass('is-active');

			// remove all top paddings
			tabItems.css({
				'padding-top': '',
				'padding-bottom': '',
			});
		});

		// get clicks on title [above the breakpoint]
		$wg.on('click', `${WG}tabTrigger`, function() {
			if ($(this).hasClass('is-active')) {
				return;
			}
			let id = $(this).attr('id');
			tabItems.find(`[data-id=${id}]`).trigger('click');
		});

		$(window).on('scroll resize', function() {
			if (!tabsTitles.hasClass('is-sticky')) {
				initTopPosition = tabsTitles.offset().top;
			}
		});

		let timer;
		window.onresize = function() {
			clearTimeout(timer);
			timer = setTimeout(function() {
				initTopPosition = tabsTitles.offset().top;
				$(window).trigger('scroll');
			}, 100);
		};

		// reinit sliders trial
		setTimeout(() => {
			$(window).trigger('resize');
		}, 500);
	}

	generateId() {
		return Math.floor(100000 + Math.random() * 900000);
	}

	isBelowMd() {
		return window.innerWidth < 768;
	}

	// Add more functions like on above here
}
